import { Component, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormGroupDirective,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './loginbackup.component.html',
  styleUrls: ['./loginbackup.component.scss']
})
export class LoginbackupComponent implements OnInit {
  public submitted: boolean = false;
  public loaded: boolean = false;
  public auth: UntypedFormGroup = null;
  @ViewChild('authFormDirective', { static: false })
  authFormDirective: FormGroupDirective;
  readonly dmsURL = environment().dms;

  constructor(
    public formBuilder: UntypedFormBuilder,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    public toastr: ToastrService,
    public translateService: TranslateService,
    public locale: LocaleService
  ) {
    if (this.authService.userData) {
      let token = this.authService.userData.token;

      if (token) {
        this.router.navigate([`/vin-information`]);
      }
    }

    this.auth = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      lang: [this.locale.localeSubject.value]
    });
  }

  ngOnInit(): void {}

  setLocale(lang: string) {
    if (lang === 'en') this.locale.langSetter = lang;
    else if (lang === 'ar') this.locale.langSetter = lang;
  }

  get formData() {
    return this.auth.controls;
  }

  //User Login Implemetation
  login() {
    this.submitted = true;

    if (this.auth.invalid) {
      return false;
    } else {
      let credential = {
        email_username: this.formData.email.value,
        password: this.formData.password.value
      };
      this.locale.langSetter = this.auth.controls.lang.value;

      this.loaded = true;

      this.authService.Login(credential).subscribe(
        // this is calling the /auth/login API
        (res) => {
          let success = res['success'];
          let data = res['user'];
          if (success) {
            if (data.user_data.role === 'evaluator') {
              this.loaded = false;
              this.setStatus(false); // this is calling the 'auth/update/status' API
              this.toastr.success('Logged in successfully', 'Success');
              this.router.navigate([`/connectivity-test`]);
              // this.router.navigate([`/vin-information`]);
            } else {
              this.loaded = false;
              this.authService.Logout();
              this.router.navigate([`/login`]);
              this.toastr.info(
                `Looks like you are an ${data.user_data.role} please login into the DMS.`,
                'Note'
              );
            }
          }
        },
        (error) => {
          this.loaded = false;
          this.toastr.error(`${error.error.message}`, 'Error');
          return false;
        }
      );
    }
  }

  getStatus() {
    const userData: Record<any, any> = this.authService.userData;

    if (userData?.token) {
      this.authService.getStatus().subscribe((res) => {});
    }
  }

  setStatus(status: boolean) {
    this.authService.setStatus({ status }).subscribe(
      (res) => {
        if (res?.success) this.getStatus(); // this is calling the auth/fetch/status API
      },
      (error) => {}
    );
  }
}
